import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import { Button, Card, Checkbox, Form, notification, Tabs, Select } from "antd";
import _ from "lodash";

import { hideLoader, showLoader } from "../../../../modules/actions";
import Request, { API_URL, LAPI_URL } from "../../../../request";
import { connect } from "react-redux";
const Option = Select.Option

const TabPane = Tabs.TabPane;
// following variables needed for update country
let docLoaded = null;
let branchId = null;

const terms = [
  { display: 'Term-1', id: 'Term-1' },
  { display: 'Term-2', id: 'Term-2' },
  { display: 'Term-3', id: 'Term-3' },
  { display: 'Term-4', id: 'Term-4' },
  { display: 'Term-5', id: 'Term-5' },
  { display: 'Term-6', id: 'Term-6' },
  { display: 'Term-7', id: 'Term-7' },
  { display: 'Term-8', id: 'Term-8' },


];

@Form.create()
class AddBranch extends PureComponent {
  callback = (key) => {
    let inputTypes = this.state.inputTypes;

    if (branchId && inputTypes[key - 1] && !inputTypes[key - 1].opened) {
      inputTypes[key - 1].opened = true;
      if (docLoaded.paymentUpload) {
        docLoaded.paymentUpload = _.map(docLoaded.paymentUpload, (item) => {
          let ind = item.url.indexOf('http')
          item.url = ind >= 0 ? `${item.url}` : `${API_URL}${item.url}`
          return item
        })
      }

      let tempObj = {};
      _.each(inputTypes[key - 1].fields, (v, k) => {
        tempObj[v.key] = docLoaded[v.key];
      });


      setTimeout(() => {
        this.props.form.setFieldsValue(tempObj);
      }, 10);
    }
  };

  handleSubmit = (e) => {
    const { dispatch, form, afterSave } = this.props;
    const { isStateHead, branchIds, associatePartnerIds, showChannelPartner, showStaffToOtherBranch } = this.state;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData);
        values.isStateHead = isStateHead;
        values.showChannelPartner = showChannelPartner;
        values.showStaffToOtherBranch = showStaffToOtherBranch;
        values.branchIds = branchIds;
        values.branchAssociatePartner = "Branch";
        values.associatePartnerIds = associatePartnerIds;
        if (branchId) {
          values = { ...values, _id: branchId };

          dispatch(showLoader());

          let x = await Request.updateBranch(values);

          dispatch(hideLoader());

          if (!x.error) {
            notification.success({
              message: "Success",
              description: x.msg,
            });
          } else {
            notification.error({
              message: "Error Saving",
              description: x.msg,
            });
          }
        } else {
          dispatch(showLoader());

          let x = await Request.addBranch(values);

          dispatch(hideLoader());

          if (!x.error) {
            notification.success({
              message: "Success",
              description: x.msg,
            });

            if (afterSave) {
              afterSave();
            }
            form.resetFields();
            this.setState({ isStateHead: false, showChannelPartner: false, showStaffToOtherBranch: false });
            // dispatch('/all-countries')
          } else {
            notification.error({
              message: "Error Saving",
              description: x.msg,
            });
          }
        }
      }
    });
  };
  getAgentTypePlans = async (agentType = "Branch") => {
    Request.getAgentTypePlans(agentType)
      .then((daa) => {
        const result = daa.result.reduce((total, val) => {
          total.push({
            _id: val._id,
            key: val._id,
            display: val.planName,
          });
          return total;
        }, []);

        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][14].options = result;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => { });
  }
  constructor(props) {
    super(props);
    this.state = {
      showSave: 1,
      showFiles: 0,
      refreshChild: false,
      isStateHead: false,
      showChannelPartner: false,
      showStaffToOtherBranch: false,
      branchAssociatePartnerType: null,
      branchIds: [],
      associatePartnerIds: [],
      branchs: [],
      // inputTypes: [
      //   {
      //     tabTitle: "Basic Details",
      //     fields: [
      //       {
      //         label: "Branch Name",
      //         key: "branchName",
      //         required: true,
      //       },
      //       {
      //         label: "Firm Name",
      //         key: "firmName",
      //         required: true,
      //       },
      //       {
      //         label: "Address",
      //         key: "branchAddress",
      //         type: "textArea",
      //         rows: 10,
      //         required: true,
      //       },
      //       {
      //         label: "Select Country ",
      //         key: "branchCountryId",
      //         required: true,
      //         type: "select",
      //         showSearch: true,
      //         options: [],
      //         onChange: (v) => {
      //           this.props.form.setFieldsValue({
      //             branchCountryId: v,
      //             branchStateId: null,
      //             branchCityId: null,
      //           });
      //           this.loadStates(v);
      //         },
      //       },
      //       {
      //         label: "Select State",
      //         key: "branchStateId",
      //         required: true,
      //         type: "select",
      //         showSearch: true,
      //         options: [],
      //         onChange: (v) => {
      //           this.props.form.setFieldsValue({
      //             branchStateId: v,
      //             branchCityId: null,
      //           });
      //           this.loadBranches(v);
      //           this.loadCities(v);
      //         },
      //       },
      //       {
      //         label: "Select City",
      //         key: "branchCityId",
      //         required: true,
      //         showSearch: true,
      //         type: "select",
      //         options: [],
      //         onChange: (v) => {
      //           this.props.form.setFieldsValue({
      //             branchCityId: v,
      //           });
      //         },
      //       },
      //       { label: "Branch Landline Phone One  ", key: "branchPhone1" },
      //       { label: "Branch Landline Phone Two ", key: "branchPhone2" },
      //       {
      //         label: "Name",
      //         key: "branchHeadName",
      //         prefixComp: <h3>Branch Head</h3>,
      //       },
      //       {
      //         label: 'Country Code', key: 'countryCode', type: 'select', showSearch: true, options: [], onChange: v => {
      //           this.props.form.setFieldsValue({
      //             countryCode: v,
      //           });
      //         }
      //       },
      //       { label: "Phone", key: "branchHeadPhone" },
      //       { label: "Email", key: "branchHeadEmail" },

      //       {
      //         label: "Name",
      //         key: "branchManagerName",
      //         prefixComp: <h3>Branch Manager</h3>,
      //       },
      //       { label: 'Country Code', key: 'branchManagerPhoneCode', type: 'select', options: [], showSearch: true, onChange: v => this.props.form.setFieldsValue({ branchManagerPhoneCode: v }) },
      //       { label: "Phone", key: "branchManagerPhone" },
      //       { label: "Email", key: "branchManagerEmail" },

      //       {
      //         label: "Name",
      //         key: "branchHeadCounslerName",
      //         prefixComp: <h3>Branch Counsellor</h3>,
      //       },
      //       { label: 'Country Code', key: 'branchHeadCounslerPhoneCode', type: 'select', options: [], showSearch: true, onChange: v => this.props.form.setFieldsValue({ branchHeadCounslerPhoneCode: v }) },
      //       { label: "Phone", key: "branchHeadCounslerPhone" },
      //       { label: "Email", key: "branchHeadCounslerEmail" },
      //       {
      //         label: "Invoice GST",
      //         key: "invoiceGST",
      //         type: "select",
      //         showSearch: true,
      //         allowClear: true,
      //         options: ['Include', 'Exclude'],
      //         onChange: (v) => {
      //           this.props.form.setFieldsValue({
      //             invoiceGST: v,
      //           });
      //         },
      //       },
      //       // {
      //       //   label: "Type",
      //       //   key: "branchAssociatePartner",
      //       //   required: true,
      //       //   type: "select",
      //       //   options: ["Branch", "Associate Partner"],
      //       //   onChange: (v) => {
      //       //     this.getAgentTypePlans(v);
      //       //     this.setState({branchAssociatePartnerType: v});
      //       //     this.props.form.setFieldsValue({
      //       //       branchAssociatePartner: v,
      //       //     });
      //       //   },
      //       // },
      //       {
      //         label: "Plan",
      //         key: "plan",
      //         type: "select",
      //         showSearch: true,
      //         allowClear: true,
      //         options: [],
      //         required: true,
      //         onChange: (v) => {
      //           this.props.form.setFieldsValue({
      //             plan: v,
      //           });
      //         },
      //       },
      //       // {
      //       //   label: 'University Type',
      //       //   key: 'universityType',
      //       //   type: 'select',
      //       //   required: true,
      //       //   options: ['Direct', 'Channel Partner'],
      //       //   onChange: v => {
      //       //     this.props.form.setFieldsValue({
      //       //       universityType: v
      //       //     })
      //       //   }
      //       // },
      //       {
      //         label: "Need Login Id",
      //         key: "loginId",
      //         type: "select",
      //         options: ["Yes", "No"],
      //         required: true,
      //         onChange: (v) => {
      //           this.props.form.setFieldsValue({
      //             loginId: v,
      //           });
      //         },
      //       },
      //     ],
      //   },
      //   {
      //     tabTitle: "Payment Terms",
      //     opened: false,
      //     fields: [
      //       {
      //         label: "Commission",
      //         type: "number",
      //         key: "commission",
      //         rightComp: <span style={{ paddingLeft: "5px" }}>%</span>,
      //       },
      //       {
      //         label: "PAYMENT Terms",
      //         key: "paymentTerms",
      //         type: "textArea",
      //         rows: 5,
      //       },
      //       {
      //         label: 'Authorized Commission Terms',
      //         key: 'authorizedCommissionTerms',
      //         type: 'select',
      //         options: terms,
      //         mode: 'multiple',
      //         onChange: v => {
      //           this.props.form.setFieldsValue({ authorizedCommissionTerms: v })
      //         }
      //       },
      //       {
      //         label: "PAYMENT Guidelines Document",
      //         key: "paymentUpload",
      //         type: "file",
      //       },
      //       {
      //         label: "Bank Details 1",
      //         key: "bankDetails1",
      //         type: "textArea",
      //         rows: 5,
      //       },
      //       {
      //         label: "Bank Details 2",
      //         key: "bankDetails2",
      //         type: "textArea",
      //         rows: 5,
      //       },
      //       { label: 'Bank Name', key: 'bankName' },
      //       { label: 'Branch Name & Address', key: 'branchNameAddress' },
      //       { label: 'Account No', key: 'accountNumber' },
      //       { label: 'Account Name', key: 'accountName' },
      //       { label: 'IFSC Code/Swift Code', key: 'ifsc' },
      //     ],
      //   },
      // ],
      inputTypes: [
        {
          tabTitle: "Basic Details",
          fields: [

            // BASIC INFORMATION
            {
              label: "Branch Name",
              key: "branchName",
              required: true,
            },
            {
              label: "Firm Name",
              key: "firmName",
              required: true,
            },

            // COMPANY BRANDING
            {
              label: "Firm Logo",
              key: "companyLogo",
              type: "file",
            },
            {
              label: "Invoice Header Image",
              key: "invoiceHeaderImage",
              type: "file",
            },
            {
              label: "Invoice Footer Image",
              key: "invoiceFooterImage",
              type: "file",
            },

            // GST
            {
              label: "GST Number (If Applicable)",
              key: "gstNumber",
            },
            {
              label: "PAN Number (If Applicable)",
              key: "panNumber",
            },

            // ADDRESS
            {
              label: "Address",
              key: "branchAddress",
              type: "textArea",
              rows: 6,
              required: true,
            },

            // COUNTRY
            {
              label: "Select Country",
              key: "branchCountryId",
              required: true,
              type: "select",
              showSearch: true,
              options: [],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  branchCountryId: v,
                  branchStateId: null,
                  branchCityId: null,
                });

                this.loadStates(v);
              },
            },

            // STATE
            {
              label: "Select State",
              key: "branchStateId",
              required: true,
              type: "select",
              showSearch: true,
              options: [],
              onChange: (v) => {

                this.props.form.setFieldsValue({
                  branchStateId: v,
                  branchCityId: null,
                });

                this.loadBranches(v);
                this.loadCities(v);
              },
            },

            // CITY
            {
              label: "Select City",
              key: "branchCityId",
              required: true,
              showSearch: true,
              type: "select",
              options: [],
              onChange: (v) => {

                this.props.form.setFieldsValue({
                  branchCityId: v,
                });

              },
            },

            // CONTACT DETAILS
            {
              label: "Branch Landline Phone One",
              key: "branchPhone1"
            },

            {
              label: "Branch Landline Phone Two",
              key: "branchPhone2"
            },

            // GST TYPE
            {
              label: "Invoice GST",
              key: "invoiceGST",
              type: "select",
              showSearch: true,
              allowClear: true,
              options: ["Include", "Exclude"],
              onChange: (v) => {

                this.props.form.setFieldsValue({
                  invoiceGST: v,
                });

              },
            },

            // PLAN
            {
              label: "Plan",
              key: "plan",
              type: "select",
              showSearch: true,
              allowClear: true,
              options: [],
              required: true,
              onChange: (v) => {

                this.props.form.setFieldsValue({
                  plan: v,
                });

              },
            },

            // LOGIN
            {
              label: "Need Login Id",
              key: "loginId",
              type: "select",
              options: ["Yes", "No"],
              required: true,
              onChange: (v) => {

                this.props.form.setFieldsValue({
                  loginId: v,
                });

              },
            },

            // BRANCH HEAD
            {
              label: "Name",
              key: "branchHeadName",
              prefixComp: <h3>Branch Head</h3>,
            },

            {
              label: "Country Code",
              key: "countryCode",
              type: "select",
              showSearch: true,
              options: [],
              onChange: v => {

                this.props.form.setFieldsValue({
                  countryCode: v,
                });

              }
            },

            {
              label: "Phone",
              key: "branchHeadPhone"
            },

            {
              label: "Email",
              key: "branchHeadEmail"
            },

            // BRANCH MANAGER
            {
              label: "Name",
              key: "branchManagerName",
              prefixComp: <h3>Branch Manager</h3>,
            },

            {
              label: "Country Code",
              key: "branchManagerPhoneCode",
              type: "select",
              options: [],
              showSearch: true,
              onChange: v =>
                this.props.form.setFieldsValue({
                  branchManagerPhoneCode: v
                })
            },

            {
              label: "Phone",
              key: "branchManagerPhone"
            },

            {
              label: "Email",
              key: "branchManagerEmail"
            },

            // COUNSELLOR
            {
              label: "Name",
              key: "branchHeadCounslerName",
              prefixComp: <h3>Branch Counsellor</h3>,
            },

            {
              label: "Country Code",
              key: "branchHeadCounslerPhoneCode",
              type: "select",
              options: [],
              showSearch: true,
              onChange: v =>
                this.props.form.setFieldsValue({
                  branchHeadCounslerPhoneCode: v
                })
            },

            {
              label: "Phone",
              key: "branchHeadCounslerPhone"
            },

            {
              label: "Email",
              key: "branchHeadCounslerEmail"
            },

          ],
        },

        {
          tabTitle: "Payment Terms",
          opened: false,
          fields: [

            {
              label: "Commission",
              type: "number",
              key: "commission",
              rightComp: (
                <span style={{ paddingLeft: "5px" }}>
                  %
                </span>
              ),
            },

            {
              label: "PAYMENT Terms",
              key: "paymentTerms",
              type: "textArea",
              rows: 5,
            },

            {
              label: "Authorized Commission Terms",
              key: "authorizedCommissionTerms",
              type: "select",
              options: terms,
              mode: "multiple",
              onChange: v => {

                this.props.form.setFieldsValue({
                  authorizedCommissionTerms: v
                });

              }
            },

            {
              label: "PAYMENT Guidelines Document",
              key: "paymentUpload",
              type: "file",
            },

            // BANK DETAILS
            {
              label: "Bank Details 1",
              key: "bankDetails1",
              type: "textArea",
              rows: 5,
            },

            {
              label: "Bank Details 2",
              key: "bankDetails2",
              type: "textArea",
              rows: 5,
            },

            {
              label: "Bank Name",
              key: "bankName"
            },

            {
              label: "Branch Name & Address",
              key: "branchNameAddress"
            },

            {
              label: "Account No",
              key: "accountNumber"
            },

            {
              label: "Account Name",
              key: "accountName"
            },

            {
              label: "IFSC Code / Swift Code",
              key: "ifsc"
            },

          ],
        },
      ],
    };

    this.loadCountries();
    this.getAgentTypePlans('Branch');
  }

  loadBranches = (branchStateId) => {
    let params = {
      sortField: 'branchName',
      sortOrder: 'ascend',
      results: 1000,
      count: 1000,
      status: true,
      isStateHead: false
    }
    Request.loadBranch({ ...params })
      .then(resp => {
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({ id: vv._id, display: vv.branchName, branchAssociatePartner: vv.branchAssociatePartner })
          return temp
        }, [])
        this.setState({ branchs: resp.data });
      })
      .catch(err => {
        console.log(err)
      })
  }

  setFormValues = async (branchId) => {
    try {
      let { doc } = await Request.getBranch(branchId);
      if (doc) {
        docLoaded = doc;
        this.loadStates(docLoaded.branchCountryId);
        this.loadBranches(docLoaded.branchStateId);
        this.loadCities(docLoaded.branchStateId);
        this.getAgentTypePlans(docLoaded.branchAssociatePartner);

        let tempObj = {};

        let inputTypes = this.state.inputTypes;

        _.each(inputTypes[0].fields, (v, k) => {
          tempObj[v.key] = docLoaded[v.key];
        });

        if (doc.isStateHead) {
          this.setState({ isStateHead: doc.isStateHead });
        }
        if (doc.branchIds) {
          this.setState({ branchIds: doc.branchIds });
        }
        if (doc.associatePartnerIds) {
          this.setState({ associatePartnerIds: doc.associatePartnerIds });
        }
        if (doc.branchAssociatePartner) {
          this.setState({ branchAssociatePartnerType: doc.branchAssociatePartner });
        }
        if (doc.showChannelPartner) {
          this.setState({ showChannelPartner: doc.showChannelPartner });
        }
        if (doc.showStaffToOtherBranch) {
          this.setState({ showStaffToOtherBranch: doc.showStaffToOtherBranch });
        }
        setTimeout(() => {
          this.props.form.setFieldsValue(tempObj);
        }, 1000);

      }
    } catch (e) {
      console.log(e);
    }
  };

  loadCountries = () => {
    let params = {
      results: 200,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getCountriesWithoutAuth({ ...params })
      .then((resp) => {
        let countryCodes = [];
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({ _id: vv._id, display: vv.countryName });
          if (vv.countryPhoneCode && vv.countryPhoneCode !== "") {
            countryCodes.push({ id: vv.countryPhoneCode, display: vv.countryPhoneCode });
          }
          return temp;
        }, []);
        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][8].options = resp.data;
        inputTypes[0]["fields"][17].options = countryCodes;
        inputTypes[0]["fields"][21].options = countryCodes;
        inputTypes[0]["fields"][25].options = countryCodes;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  loadStates = (id) => {
    Request.loadStates(id)
      .then((daa) => {
        daa.result = daa.result.reduce((total, val) => {
          total.push({
            _id: val._id,
            key: val._id,
            display: val.stateName,
          });
          return total;
        }, []);

        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][9].options = daa.result;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => { });
  };

  loadCities = (id) => {
    Request.loadCities(id)
      .then((daa) => {
        daa.result = daa.result.reduce((total, val) => {
          total.push({
            _id: val._id,
            key: val._id,
            display: val.cityName,
          });
          return total;
        }, []);
        let inputTypes = this.state.inputTypes;
        inputTypes[0]["fields"][10].options = daa.result;
        this.setState({ inputTypes: inputTypes });
        this.refreshFxn();
      })
      .catch((err) => { });
  };

  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild });
  };


  componentDidMount() {
    this.loadCountries();
    let searchParams = new URLSearchParams(this.props.search);
    branchId = searchParams.get("_id");

    if (branchId) {
      this.setState({ showFiles: 1 });
      this.setFormValues(branchId);
    }
  }

  render() {
    const {
      formOnly,
      form: { getFieldDecorator },
    } = this.props;

    // const submitFormLayout = {
    //   wrapperCol: {
    //     xs: { span: 24, offset: 0 },
    //     sm: { span: 10, offset: 7 },
    //     md: { span: 12, offset: 8 },
    //   },
    // };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 8 },
        md: { span: 8 },
      },
    };
    let { branchs, branchAssociatePartnerType } = this.state;
    let mainBranchs = branchs.filter((branch) => { return branch.branchAssociatePartner == 'Branch' });
    let associatePartners = branchs.filter((branch) => { return branch.branchAssociatePartner == 'Associate Partner' });
    let form = (
      <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
        <Card bordered={true}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginBottom: 10 }}
            loading={this.props.loading}
          >
            SAVE
          </Button>
          <Tabs onChange={this.callback} type="card">
            {this.state.inputTypes.map((itype, key) => {
              return (
                <TabPane tab={itype.tabTitle} key={key + 1}>
                  {key === 0 && (
                    <>
                      <Form.Item label={"Head Office"} {...formItemLayout}>
                        <Checkbox
                          checked={this.state.isStateHead}
                          onChange={(y) => {
                            this.setState({ isStateHead: y.target.checked });
                          }}
                        />
                      </Form.Item>
                      <Form.Item label={"Show Channel Partner"} {...formItemLayout}>
                        <Checkbox
                          checked={this.state.showChannelPartner}
                          onChange={(y) => {
                            this.setState({ showChannelPartner: y.target.checked });
                          }}
                        />
                      </Form.Item>
                      <Form.Item label={"Show Staff To Other Branch"} {...formItemLayout}>
                        <Checkbox
                          checked={this.state.showStaffToOtherBranch}
                          onChange={(y) => {
                            this.setState({ showStaffToOtherBranch: y.target.checked });
                          }}
                        />
                      </Form.Item>
                    </>
                  )}
                  <GetAllFormFields
                    apiurl={LAPI_URL}
                    inputSchema={this.state.inputTypes[key]}
                    refresh={this.refreshFxn}
                    getFieldDecorator={getFieldDecorator}
                  />
                  {key === 0 && this.state.isStateHead == true && (
                    <Form.Item label={"Select Branches (" + (this.state.branchIds.length) + ")"} {...formItemLayout}>
                      <Select
                        allowClear
                        style={{ width: '550px' }}
                        showSearch={true}
                        mode="multiple"
                        value={this.state.branchIds}
                        placeholder="Select Option"
                        optionFilterProp="display"
                        filterOption={(input, option) => {
                          return (
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          )
                        }}
                        onChange={branchIds => {
                          this.setState(
                            {
                              branchIds
                            }
                          )
                        }}>
                        {mainBranchs.map((val, idn) => {
                          return (
                            <Option key={idn} value={val.id}>
                              {val.display}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  )}
                  {key === 0 && branchAssociatePartnerType == 'Branch' && (
                    <Form.Item label={"Sub Agents " + ("(" + this.state.associatePartnerIds.length + ")")} {...formItemLayout}>
                      <Select
                        allowClear
                        style={{ width: '550px' }}
                        showSearch={true}
                        mode="multiple"
                        value={this.state.associatePartnerIds}
                        placeholder="Select Option"
                        optionFilterProp="display"
                        filterOption={(input, option) => {
                          return (
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          )
                        }}
                        onChange={associatePartnerIds => {
                          this.setState(
                            {
                              associatePartnerIds
                            }
                          )
                        }}>
                        {associatePartners.map((val, idn) => {
                          return (
                            <Option key={idn} value={val.id}>
                              {val.display}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  )}
                </TabPane>
              );
            })}
          </Tabs>
        </Card>
      </Form>
    );

    return (
      <React.Fragment>
        {!formOnly ? (
          <PageHeaderWrapper title={"Add New Branch"}>{form}</PageHeaderWrapper>
        ) : (
          form
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddBranch);
